export default __webpack_public_path__ + "static/media/profile.523ebc6d.png";